import { useId } from "react";
import PropTypes from "prop-types";

import { data } from "./data";

import SignupBoxItem from "components/signup-box-item";

import styles from "./styles.module.css";

const SignupBoxes = ({ signupType }) => {
  const id = useId();

  return (
    <ul className={styles.wrapper}>
      {data
        .filter((x) => x.type === signupType)
        .map((item, index) => (
          <li key={`${id}-${index}`}>
            <SignupBoxItem data={item} />
          </li>
        ))}
    </ul>
  );
};

SignupBoxes.propTypes = {
  signupType: PropTypes.string,
};

export default SignupBoxes;
